export default "__VITE_ASSET__9cac20db__"